import React from "react"
import { useFlags } from "flagsmith/react"
import { getProviderName, ProvidersType } from "@/types/providers.types"

interface TrackingUnavailableMessageProps {
  provider: ProvidersType
}

const TrackingUnavailableMessage: React.FC<TrackingUnavailableMessageProps> = (props) => {
  const flags = useFlags([
    "grab_no_tracking",
    "lalamove_no_tracking",
    "pandago_no_tracking",
    "zeek_no_tracking",
    "pickupp_no_tracking",
    "qxpress_no_tracking",
    "ifood_no_tracking",
    "teleport_no_tracking",
    "gogox_no_tracking",
    "borzo_no_tracking",
    "ninjavan_no_tracking",
    "jnt_no_tracking",
    "rappi_no_tracking",
    "milkrun_no_tracking",
    "kosmo_no_tracking",
    "uber_no_tracking",
    "tada_no_tracking",
  ])

  const providerFlags = {
    [ProvidersType.GRAB]: flags.grab_no_tracking.enabled,
    [ProvidersType.LALAMOVE]: flags.lalamove_no_tracking.enabled,
    [ProvidersType.PANDAGO]: flags.pandago_no_tracking.enabled,
    [ProvidersType.ZEEK]: flags.zeek_no_tracking.enabled,
    [ProvidersType.PICKUPP]: flags.pickupp_no_tracking.enabled,
    [ProvidersType.QXPRESS]: flags.qxpress_no_tracking.enabled,
    [ProvidersType.IFOOD]: flags.ifood_no_tracking.enabled,
    [ProvidersType.TELEPORT]: flags.teleport_no_tracking.enabled,
    [ProvidersType.GOGOX]: flags.gogox_no_tracking.enabled,
    [ProvidersType.BORZO]: flags.borzo_no_tracking.enabled,
    [ProvidersType.NINJAVAN]: flags.ninjavan_no_tracking.enabled,
    [ProvidersType.JNT]: flags.jnt_no_tracking.enabled,
    [ProvidersType.RAPPI]: flags.rappi_no_tracking.enabled,
    [ProvidersType.MILKRUN]: flags.milkrun_no_tracking.enabled,
    [ProvidersType.UBER]: flags.uber_no_tracking.enabled,
    [ProvidersType.TADA]: flags.tada_no_tracking.enabled,
    [ProvidersType.GOGET]: false,
    [ProvidersType.KOSMO]: flags.kosmo_no_tracking.enabled,
    [ProvidersType.OWN_FLEET]: false,
    [ProvidersType.KOSMO_NETWORK]: false,
  }

  const isNoTrackingDisplayed = (provider: ProvidersType) => {
    return !!providerFlags[provider]
  }

  return (
    <>
      {isNoTrackingDisplayed(props.provider) && (
        <p className="italic text-sm text-center mt-3 text-stone-500">
          Due to a provider issue, {getProviderName(props.provider)} live tracking is temporarily
          unavailable
        </p>
      )}
    </>
  )
}

export default TrackingUnavailableMessage
